import * as React from "react";

const SvgComponent = () => (
  <svg width="80.000000" height="80.000000" viewBox="0 0 80 80" fill="none">
    <defs>
      <clipPath id="clip1360_9571">
        <rect id="Frame" width="80.000000" height="80.000000" fill="white" fill-opacity="0" />
      </clipPath>
    </defs>
    <rect id="Frame" width="80.000000" height="80.000000" fill="#FFFFFF" fill-opacity="0" />
    <g clip-path="url(#clip1360_9571)">
      <path
        id="Vector"
        d="M13.33 63.33L13.33 16.66L31.95 16.66L38.61 23.33L66.66 23.33L66.66 63.33L13.33 63.33ZM69.99 16.66L41.37 16.66L34.71 10L9.99 10C8.15 10 6.66 11.49 6.66 13.33L6.66 66.66C6.66 68.5 8.15 70 9.99 70L69.99 70C71.84 70 73.33 68.5 73.33 66.66L73.33 20C73.33 18.15 71.84 16.66 69.99 16.66ZM50 42.22L33.73 31.38C33.51 31.23 33.26 31.15 32.99 31.15C32.26 31.15 31.66 31.75 31.66 32.49L31.66 54.17C31.66 54.43 31.74 54.69 31.88 54.91C32.29 55.52 33.12 55.69 33.73 55.28L50 44.44C50.14 44.34 50.27 44.21 50.37 44.07C50.78 43.46 50.61 42.63 50 42.22Z"
        fill="var(--vos-red)"
        fill-opacity="1.000000"
        fill-rule="nonzero"
      />
    </g>
  </svg>
);

export default SvgComponent;
